import NavbarA from "../images/thumbnail/NavbarA.jpg";
import Navbar02 from "../images/thumbnail/Navbar02.jpg";
import Navbar03 from "../images/thumbnail/Navbar03.jpg";
import Navbar04 from "../images/thumbnail/Navbar04.jpg";
import Navbar01 from "../images/thumbnail/Navbar01.jpg";
import NavbarC from "../images/thumbnail/NavbarC.jpg";
import Navbar07 from "../images/thumbnail/Navbar07.jpg";
import Navbar08 from "../images/thumbnail/Navbar08.jpg";
import NavbarB from "../images/thumbnail/NavbarB.jpg";
import Navbar09 from "../images/thumbnail/Navbar09.jpg";
import Navbar10 from "../images/thumbnail/Navbar10.jpg";
import NavbarD from "../images/thumbnail/NavbarD.jpg";
import Navbar12 from "../images/thumbnail/Navbar12.jpg";
import Navbar11 from "../images/thumbnail/Navbar11.jpg";
import NavbarE from "../images/thumbnail/NavbarE.jpg";
import Navbar06 from "../images/thumbnail/Navbar06.jpg";
import NavbarG from "../images/thumbnail/NavbarG.jpg";
import NavbarF from "../images/thumbnail/NavbarF.jpg";
import NavbarH from "../images/thumbnail/NavbarH.jpg";
import Navbar05 from "../images/thumbnail/Navbar05.jpg";

import './naviConfig.css'

//path1 navi中文版
const thumbnailPath1Config =(langCh)=> [
    //args:[gotoscene, goToYaw, goToPitch]
    {thumbnail:NavbarG ,thumbnailLabel:langCh?'戰情室':'Corporate Situation Room',         thumbnailClass: 'thumbnail', args:[12,20,0]},
    {thumbnail:NavbarF ,thumbnailLabel:langCh?'智慧三元素':'Smart Manufacturing',     thumbnailClass: 'thumbnail', args:[12,-30,0]},
    {thumbnail:NavbarH ,thumbnailLabel:langCh?'智慧自動化':'Smart Automation',       thumbnailClass: 'thumbnail', args:[11,90,0]},
    
    {thumbnail:NavbarA, thumbnailLabel:langCh?'零件加工':'General Machining',       thumbnailClass: 'thumbnail', args:[1,45,0]},
    {thumbnail:Navbar02,thumbnailLabel:'NFX400A-MPS',   thumbnailClass: 'thumbnail', args:[2,45,0]},
    {thumbnail:Navbar03,thumbnailLabel:'UV 650',         thumbnailClass: 'thumbnail', args:[3,45,0]},
    {thumbnail:Navbar04,thumbnailLabel:'NTC 2000LSY',    thumbnailClass: 'thumbnail', args:[5,45,0]},
    {thumbnail:Navbar01,thumbnailLabel:'NXV 1270A',     thumbnailClass: 'thumbnail', args:[4,60,0]},
    
    {thumbnail:NavbarE ,thumbnailLabel:langCh?'模具加工':'Die & Mold',    thumbnailClass: 'thumbnail', args:[10,-70,0]},
    {thumbnail:Navbar05 ,thumbnailLabel:'NSV 106AMS',     thumbnailClass: 'thumbnail', args:[15,0,-30]},
    {thumbnail:Navbar06,thumbnailLabel:'DCV 2018B-5AX',  thumbnailClass: 'thumbnail', args:[11,-60,0]},

    {thumbnail:NavbarD ,thumbnailLabel:langCh?'汽機車產業加工':'Automotive',     thumbnailClass: 'thumbnail', args:[6,-80,0]},
    {thumbnail:Navbar12,thumbnailLabel:'NH 500AW',       thumbnailClass: 'thumbnail', args:[7,-60,0]},
    {thumbnail:Navbar11,thumbnailLabel:'NSV 106AS',      thumbnailClass: 'thumbnail', args:[8,-60,0]},

    {thumbnail:NavbarC ,thumbnailLabel:langCh?'航太產業加工':'Aerospace',       thumbnailClass: 'thumbnail', args:[1,-45,0]},
    {thumbnail:Navbar07,thumbnailLabel:'NFP500A-5AX',   thumbnailClass: 'thumbnail', args:[2,-45,0]},
    {thumbnail:Navbar08,thumbnailLabel:'DCV2018A-5AX',  thumbnailClass: 'thumbnail', args:[3,-45,0]},
    
    {thumbnail:NavbarB ,thumbnailLabel:langCh?'細微加工':'Micromachining',       thumbnailClass: 'thumbnail', args:[7,70,0]},
    {thumbnail:Navbar09,thumbnailLabel:'NFP66A',        thumbnailClass: 'thumbnail', args:[8,55,0]},
    {thumbnail:Navbar10,thumbnailLabel:'NXV600A',       thumbnailClass: 'thumbnail', args:[9,55,0]},
    ]

//path2 navi中文版
const thumbnailPath2Config=(langCh) => [
    //args:[gotoscene, goToYaw, goToPitch]

    {thumbnail:NavbarG ,thumbnailLabel:langCh?'戰情室':'Corporate Situation Room',         thumbnailClass: 'thumbnail', args:[6,0,0]},
    {thumbnail:NavbarF ,thumbnailLabel:langCh?'智慧智造解決方案':'Smart Manufacturing',     thumbnailClass: 'thumbnail', args:[5,0,0]},
    {thumbnail:NavbarH ,thumbnailLabel:langCh?'智慧自動化':'Smart Automation',       thumbnailClass: 'thumbnail', args:[18,0,0]},

    {thumbnail:NavbarA, thumbnailLabel:langCh?'零件加工':'General Machining',       thumbnailClass: 'thumbnail', args:[23,-44.5,-12]},
    {thumbnail:Navbar02,thumbnailLabel:'NFX400A-MPS',   thumbnailClass: 'thumbnail', args:[7,0,0]},
    {thumbnail:Navbar03,thumbnailLabel:'UV 650 Flexcell',         thumbnailClass: 'thumbnail', args:[8,0,0]},
    {thumbnail:Navbar04,thumbnailLabel:'NTC 2000LSY',    thumbnailClass: 'thumbnail', args:[10,0,0]},
    {thumbnail:Navbar01,thumbnailLabel:'NXV 1270A',     thumbnailClass: 'thumbnail', args:[9,0,7]},

    {thumbnail:NavbarE ,thumbnailLabel:langCh?'模具加工':'Die & Mold',    thumbnailClass: 'thumbnail', args:[27,44.5,-12]},
    {thumbnail:Navbar05 ,thumbnailLabel:'NSV 106AMS',     thumbnailClass: 'thumbnail', args:[20,-45,-30]},
    {thumbnail:Navbar06,thumbnailLabel:'DCV 2018B-5AX',  thumbnailClass: 'thumbnail', args:[17,0,0]},    

    {thumbnail:NavbarD ,thumbnailLabel:langCh?'汽機車產業加工':'Automotive',     thumbnailClass: 'thumbnail', args:[26,44.5,-12]},
    {thumbnail:Navbar12,thumbnailLabel:'NH 500AW',       thumbnailClass: 'thumbnail', args:[15,0,0]},
    {thumbnail:Navbar11,thumbnailLabel:'NSV 106AS',      thumbnailClass: 'thumbnail', args:[16,0,0]},

    {thumbnail:NavbarC ,thumbnailLabel:langCh?'航太產業加工':'Aerospace',       thumbnailClass: 'thumbnail', args:[25,44.5,-12]},
    {thumbnail:Navbar07,thumbnailLabel:'NFP500A-5AX',   thumbnailClass: 'thumbnail', args:[13,0,0]},
    {thumbnail:Navbar08,thumbnailLabel:'DCV2018A-5AX',  thumbnailClass: 'thumbnail', args:[14,0,0]},
    
    {thumbnail:NavbarB ,thumbnailLabel:langCh?'細微加工':'Micromachining',       thumbnailClass: 'thumbnail', args:[24,-44.5,-12]},
    {thumbnail:Navbar09,thumbnailLabel:'NFP66A',        thumbnailClass: 'thumbnail', args:[11,0,0]},
    {thumbnail:Navbar10,thumbnailLabel:'NXV600A',       thumbnailClass: 'thumbnail', args:[12,0,0]},
    ]

export {thumbnailPath1Config,
        thumbnailPath2Config
    }